module.exports = __webpack_public_path__ + "static/media/toto-inversed-square.e3b0368a.png";